module.exports = __webpack_public_path__ + "img/main_videoback.2315e530.png";